module.exports = __webpack_public_path__ + "static/media/e4.3c63a08e.jpg";